import React from 'react'

export const NothingSelected = () => {
    return (
        <div className="nothing__main-content">
            <p>
                Select someting
                <br />
                create a entry
            </p>

            <i className="far fa-star fa-4x-"></i>
        </div>
    )
}
